export function dateTickFormat(date) {
  const hour = date.toLocaleString('en-US', {
    hour: 'numeric',
    timeZone: 'America/Los_Angeles',
  });
  const day = date.toLocaleString('en-US', {
    weekday: 'short',
    timeZone: 'America/Los_Angeles',
  });

  return `${hour} \n${day}`;
}

export function dateFormat(date) {
  const monthDay = date.toLocaleString('en-US', {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    timeZone: 'America/Los_Angeles',
  });
  const time = date.toLocaleString('en-US', {
    hour: 'numeric',
    timeZone: 'America/Los_Angeles',
  });

  return `${monthDay} \n${time}`;
}

export const elevationFormatter = new Intl.NumberFormat('en-US', {
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

export const windFormatter = new Intl.NumberFormat('en-US', {
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

export const precipFormatter = new Intl.NumberFormat('en-US', {
  minimumFractionDigits: 0,
  maximumFractionDigits: 1,
});
